import { ReactElement } from 'react';
import styled from 'styled-components';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { isEmpty } from 'lodash';

const ButtonsContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

interface Props {
    onAdd: () => void;
    onRemove: () => void;
    canAdd?: boolean;
    canRemove?: boolean;
    ctaButtons?: JSX.Element[];
    addLeftMargin?: boolean;
}

export const MultipleFieldsButton = styled(Button)<{
    addLeftMargin?: boolean;
}>`
    background-color: transparent;
    border-color: #cecece;
    border-radius: 4px;
    ${({ addLeftMargin }) => addLeftMargin && 'margin-left: 2rem;'}

    color: #cecece;
    font-weight: 400;

    transition: 100ms;

    :focus {
        background-color: transparent;
        border-color: link;
        color: #cecece;
    }

    :hover {
        background-color: initial;
        border-color: link;
        color: #cecece;
    }
`;

const MultipleButtons = ({
    onAdd,
    onRemove,
    canAdd = true,
    canRemove,
    ctaButtons,
    addLeftMargin,
}: Props): ReactElement => {
    return (
        <ButtonsContainer>
            {canRemove && (
                <MultipleFieldsButton addLeftMargin={addLeftMargin} onClick={onRemove} icon={<MinusOutlined />} />
            )}
            {canAdd && <MultipleFieldsButton addLeftMargin={addLeftMargin} onClick={onAdd} icon={<PlusOutlined />} />}
            {!isEmpty(ctaButtons) && ctaButtons}
        </ButtonsContainer>
    );
};

export default MultipleButtons;
